<style scoped>
    .gengxinrizhi {
        border-bottom: 1px solid #f5f5f5;
        padding: 20px;
    }

    .nomore {
        text-align: center;
        color: #aaa;
        padding: 10px;
    }
</style>
<template>
    <div>
        <div style="padding:20px;box-sizing: border-box;position: fixed;background-color: #fff;z-index: 1000;width: 440px;">
            <div style="font-size: 20px;font-weight: bold;padding: 10px 0;">更新日志</div>
            <!-- search -->
            <Input v-if="!query.keywords" ref="input:keywords" v-model="keywords" icon="ios-search" :placeholder="'搜索'" @on-enter="keywordsChanged">
            </Input>
            <div v-if="(!!query.keywords)" @click="keywordsEdit" class="jcsb nowrap" :style="`height: 32px;line-height: 32px;margin: 0;width: 100%;background-color: #f5f5f5;color: #aaa;padding: 0 8px;border-radius: 4px;`">
                <div>{{query.keywords}}</div>
                <Icon type="ios-close-circle" @click.stop="keywordsClear"></Icon>
            </div>
        </div>
        <div style="height: 100px;"></div>
        <Scroll ref="list" :on-reach-top="refresh" :on-reach-bottom="loadMore" :distance-to-edge="20" :height="listHeight">
            <div v-for="(gengxinrizhi,index) of gengxinrizhis" class="gengxinrizhi" :style="`background-color: ${index%2==0?'#fff':'#fafafa'};`">
                <Badge :dot="newversiontip(gengxinrizhi)" :offset="[5,-6]">
                    <div style="font-size: 18px;font-weight: bold;">
                        <Icon type="md-bookmark" />
                        {{gengxinrizhi.version}}
                    </div>
                </Badge>
                <div style="font-size: 14px;color: #aaa;margin-bottom: 10px;">文档更新于 {{gengxinrizhi.lastUpdateTimeStr}}</div>
                <div v-html="gengxinrizhi.content"></div>
            </div>
            <div v-if="nomore" class="nomore">没有更多了</div>
            <div style="height: 20px;"></div>
        </Scroll>
    </div>
</template>
<script>


    export default {
        props: {
            current: String,
        },
        data() {
            return {
                session: this.$store.session,
                keywords: '',
                query: {
                    keywords: '',
                    from: {
                        version: null,
                        _id: null,
                    },
                    size: 20,
                    client: 'web',
                },
                loading: false,
                loadingmore: false,
                nomore: false,
                gengxinrizhis: [],
                listHeight: 400,
            }
        },
        mounted() {
            this.loadData()
            setTimeout(() => {
                this.calcListHeight()
            }, 330);
        },
        methods: {
            newversiontip(gengxinrizhi) {
                return compareVersions(gengxinrizhi ? gengxinrizhi.version : '0.0.0', this.current)
            },
            calcListHeight() {
                this.listHeight = window.innerHeight - this.$refs['list'].$el.offsetTop - 20
            },
            keywordsChanged() {
                this.query.keywords = this.keywords
                this.refresh()
            },
            keywordsEdit() {
                this.query.keywords = ''
                setTimeout(() => {
                    let input = this.$refs[`input:keywords`][0]
                    if (input) input.focus()
                }, 200)
            },
            keywordsClear() {
                this.query['keywords'] = ''
                this.keywords = ''
                setTimeout(() => {
                    let input = this.$refs[`input:keywords`][0]
                    if (input) input.focus()
                }, 200)
                this.refresh()
            },
            async loadData() {
                if (this.loading || this.nomore) return
                this.loading = true
                let res = await this.$api.post('/web/main/gengxinrizhi/list', {
                    query: this.query,
                })
                this.loading = false
                if (res.data.gengxinrizhis.length < this.query.size) {
                    this.nomore = true
                }
                if (this.query.from._id) {
                    this.gengxinrizhis = this.gengxinrizhis.concat(res.data.gengxinrizhis)
                } else {
                    this.gengxinrizhis = res.data.gengxinrizhis
                }
                for (let gengxinrizhi of this.gengxinrizhis) {
                    gengxinrizhi.lastUpdateTimeStr = this.moment(gengxinrizhi.lastUpdateTime || gengxinrizhi.createTime).format('YYYY-MM-DD HH:mm:ss')
                    if (gengxinrizhi.content) gengxinrizhi.content = gengxinrizhi.content.replace(/<img/g, '<img style="max-width: 100%;"')
                    if (this.query.keywords) {
                        if (gengxinrizhi.content) gengxinrizhi.content = gengxinrizhi.content.replace(new RegExp(this.query.keywords, 'g'), `<span style="color: #333;background-color:yellow;font-weight:bold">${this.query.keywords}</span>`)
                    }
                }
            },
            async loadMore() {
                if (this.loading || this.nomore || this.loadingmore) return
                this.query.from = {
                    version: this.gengxinrizhis[this.gengxinrizhis.length - 1].version,
                    _id: this.gengxinrizhis[this.gengxinrizhis.length - 1]._id,
                }
                this.loadingmore = true
                await this.loadData()
                this.loadingmore = false
            },
            async refresh() {
                this.nomore = false
                this.query.from = {
                    version: null,
                    _id: null,
                }
                await this.loadData()
            },
        },
    };

    function compareVersions(version1, version2) {
        const parts1 = version1.split('.').map(Number);
        const parts2 = version2.split('.').map(Number);

        for (let i = 0; i < parts1.length; i++) {
            if (parts1[i] > parts2[i]) {
                return true;
            } else if (parts1[i] < parts2[i]) {
                return false;
            }
        }

        return false;
    }
</script>


// WEBPACK FOOTER //
// src/components/common/Updatelog.vue?b2c04704